// extracted by mini-css-extract-plugin
export default {"title":"AddGuestsComponent_title__Qrd9q","iconEdit":"AddGuestsComponent_iconEdit__L6gkO","subTitle":"AddGuestsComponent_subTitle__RoE3u"};